import React, { useState, useEffect } from 'react';
import { Country, State } from 'country-state-city';
import { Form, Input, Select } from 'antd';
import { FormItem, RowWrapper } from 'component/form_component/style';

export default function Address({ formTab2, singleUserData, className }) {
  const [states, setStates] = useState([]);

  const handleCountryChange = (selectedCountry) => {
    const selectedCountryData = Country.getAllCountries().find((country) => country.name === selectedCountry);

    if (selectedCountryData) {
      const selectedCountryStates = State.getStatesOfCountry(selectedCountryData.isoCode);
      setStates(selectedCountryStates);
    } else {
      setStates([]); // If the selected country is not found, clear the state options
    }
    // Clear the state field value
    formTab2.setFieldsValue({ state: undefined });
  };

  useEffect(() => {
    if (singleUserData?.country) {
      const selectedCountryData = Country.getAllCountries().find(
        (countryData) => countryData.name === singleUserData.country
      );
      const selectedCountryISOCode = selectedCountryData ? selectedCountryData.isoCode : '';
      const selectedCountryStates = State.getStatesOfCountry(selectedCountryISOCode);
      setStates(selectedCountryStates);
    }
  }, [singleUserData]);

  return (
    <Form
      className={className}
      form={formTab2}
      layout='vertical'
      initialValues={{
        street: singleUserData?.street ? singleUserData.street : '',
        poBox: singleUserData?.poBox ? singleUserData.poBox : '',
        zip: singleUserData?.zip ? singleUserData.zip : '',
        city: singleUserData?.city ? singleUserData.city : '',
        state: singleUserData?.state ? singleUserData.state : null,
        country: singleUserData?.country ? singleUserData.country : null,
      }}
    >
      <RowWrapper className={`${className} row-wrapper1`}>
        <FormItem
          key='street'
          name='street'
          label='Street'
          className={`${className} address-form-item address-form-item_street`}
        >
          <Input className={`${className} address-form-input address-form-input_street`} />
        </FormItem>

        <FormItem
          key='country'
          name='country'
          label='Country/Region'
          className={`${className} address-form-item address-form-item_country`}
        >
          <Select
            className={`${className} address-form-select address-form-select_country`}
            showSearch
            placeholder='Select a Country'
            onChange={handleCountryChange}
            allowClear={true}
          >
            {Country.getAllCountries().map((country) => (
              <Select.Option
                className={`${className} address-form-select address-form-select-option address-form-select-option_country`}
                key={country.isoCode}
                value={country.name}
              >
                {country.name}
              </Select.Option>
            ))}
          </Select>
        </FormItem>
      </RowWrapper>

      <RowWrapper className={`${className} row-wrapper2`}>
        <FormItem
          key='state'
          name='state'
          label='State/Province'
          className={`${className} address-form-item address-form-item_state`}
        >
          <Select
            showSearch
            placeholder='Select a state'
            allowClear={true}
            className={`${className} address-form-select address-form-select_state`}
          >
            {states.map((state) => (
              <Select.Option
                className={`${className} address-form-select address-form-select-option address-form-select-option_state`}
                key={state.isoCode}
                value={state.name}
              >
                {state.name}
              </Select.Option>
            ))}
          </Select>
        </FormItem>

        <FormItem
          key='city'
          name='city'
          label='City'
          className={`${className} address-form-item address-form-item_city`}
        >
          <Input className={`${className} address-form-input address-form-input_city`} />
        </FormItem>
      </RowWrapper>

      <RowWrapper className={`${className} row-wrapper3`}>
        <FormItem
          key='poBox'
          name='poBox'
          label='P.O.Box'
          className={`${className} address-form-item address-form-item_pobox`}
        >
          <Input className={`${className} address-form-input address-form-input_pobox`} />
        </FormItem>

        <FormItem
          key='zip'
          name='zip'
          label='Zip/PostalCode'
          className={`${className} address-form-item address-form-item_zip`}
        >
          <Input className={`${className} address-form-input address-form-input_zip`} />
        </FormItem>
      </RowWrapper>
    </Form>
  );
}
